import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetRelatedIpc } from '@/infrastructure/api-functions/interface/get-related-ipc.interface';
import type { AISearchRepository } from '../../service/ai-search.repository.interface';

export const GetRelatedIpcDTO = Symbol('GetRelatedIpcDTO');

export interface GetRelatedIpcDTO {
    fetch: AISearchRepository['getRelatedIpc'];
}

@injectable()
export class GetRelatedIpcDTOImpl implements GetRelatedIpcDTO {
    constructor(
        @inject(GetRelatedIpc)
        private readonly _getRelatedIpcApi: GetRelatedIpc,
    ) { }

    async fetch(value: string, type: string) {
        try {
            const data = await this._getRelatedIpcApi.getRelatedIpc({ text: value, type });
            return data.map(item => ({ id: item.code, code: item.code, desc: item.desc }));

        } catch (error) {
            return [];
        }
    }
}